








































































































































import { UserActionContexts } from '@/constants/urls'
import {
  PatientManagementWizardDetailedPatientInformationKeys as DetailedPatientInformationKeys,
  VibePackageDeviceTypes as PackageDeviceTypes,
} from '@/constants/patients'

export default {
  props: {
    packageVibe: {
      type: Object,
      default: null,
    },
    patientInformation: {
      type: Object,
      default: null,
    },
    patientNoun: {
      type: String,
      required: true,
    },
    userActionContext: {
      type: String,
      required: true,
    },
    [PackageDeviceTypes.Vibe]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Gateway]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Tracker]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Inhaler]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.PulseOximeter]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Scale]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Thermometer]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Bpm]: {
      type: String,
      default: '',
    },
    [PackageDeviceTypes.Glucometer]: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      DeviceTypes: {
        Vibe: PackageDeviceTypes.Vibe,
        Gateway: PackageDeviceTypes.Gateway,
        Tracker: PackageDeviceTypes.Tracker,
        Inhaler: PackageDeviceTypes.Inhaler,
        PulseOximeter: PackageDeviceTypes.PulseOximeter,
        Scale: PackageDeviceTypes.Scale,
        Thermometer: PackageDeviceTypes.Thermometer,
        Bpm: PackageDeviceTypes.Bpm,
        Glucometer: PackageDeviceTypes.Glucometer,
      },
      newPackageId: '',
      customVibeIds: [],
      confirmSkipThisStage: false,
      showNewPackageIdDialog: false,
    }
  },

  computed: {
    contextIsNew() {
      return this.userActionContext === UserActionContexts.New
    },
    deviceAssignmentIsValid() {
      return (
        (this.validateDeviceId(this.modemId) || (!this.modemId && !this.vibeId)) &&
        (this.validateDeviceId(this.trackerId) || !this.trackerId) &&
        (this.validateDeviceId(this.inhalerId) || !this.inhalerId) &&
        (this.validateDeviceId(this.pulseOximeterId) || !this.pulseOximeterId) &&
        (this.validateDeviceId(this.scaleId) || !this.scaleId) &&
        (this.validateDeviceId(this.thermometerId) || !this.thermometerId) &&
        (this.validateDeviceId(this.bpmId) || !this.bpmId) &&
        (this.validateDeviceId(this.glucometerId) || !this.glucometerId)
      )
      // return this.packageVibe || this.confirmSkipThisStage
    },
    vibePackage() {
      return this.patientInformation && this.patientInformation[DetailedPatientInformationKeys.VibePackage]
    },
    availableVibes() {
      return (this.patientInformation && this.patientInformation[DetailedPatientInformationKeys.AvailableVibes]) || []
    },
    packageIdOptions() {
      let options = []
      let assignedPackage =
        this.patientInformation && this.patientInformation[DetailedPatientInformationKeys.VibePackage]
      if (assignedPackage && assignedPackage[PackageDeviceTypes.Vibe]) {
        options.push(assignedPackage[PackageDeviceTypes.Vibe])
      } else {
        console.log('no assigned package found in patientInformation')
      }
      return [...options, ...this.availableVibes, ...this.customVibeIds]
    },
    // vibe id
    vibeId() {
      return this[PackageDeviceTypes.Vibe]
      // return this.packageVibe && this.packageVibe.vibeId
    },
    modemId() {
      return this[PackageDeviceTypes.Gateway]
    },
    trackerId() {
      return this[PackageDeviceTypes.Tracker]
    },
    inhalerId() {
      return this[PackageDeviceTypes.Inhaler]
    },
    pulseOximeterId() {
      return this[PackageDeviceTypes.PulseOximeter]
    },
    scaleId() {
      return this[PackageDeviceTypes.Scale]
    },
    thermometerId() {
      return this[PackageDeviceTypes.Thermometer]
    },
    bpmId() {
      return this[PackageDeviceTypes.Bpm]
    },
    glucometerId() {
      return this[PackageDeviceTypes.Glucometer]
    },
  },

  watch: {
    deviceAssignmentIsValid: {
      immediate: true,
      handler() {
        this.$emit('updateValidationState', this.deviceAssignmentIsValid)
      },
    },
  },

  methods: {
    getWarning(type) {
      if (this[type] && !this.validateDeviceId(this[type])) {
        return `invalid ID`
      }
      let vPackage = this.vibePackage
      let device = vPackage && vPackage.devices.filter(t => t.type == type)
      return device && device[0] && device[0].warning
    },
    validateDeviceId(deviceId) {
      return (
        deviceId && deviceId.length === 17 && deviceId.match(/^[0-9A-F]{1,2}(_)(?:[0-9A-F]{1,2}\1){4}[0-9A-F]{1,2}$/)
      )
    },
    setExistingPackageId(event) {
      this.$emit('updatePackageId', event && event.vibeId)
      // this.$emit('update:packageId', event && event.vibeId)
    },
    closeNewPackageIdDialog() {
      this.newPackageId = ''
      this.showNewPackageIdDialog = false
    },
    createNewPackageId() {
      let newPackage = {
        vibeId: this.newPackageId,
      }
      // this.packageIdOptions.push(this.newPackageId)
      this.customVibeIds.push(newPackage)
      this.$emit('updatePackageId', this.newPackageId)
      // this.$emit('update:packageId', this.newPackageId)
      this.newPackageId = ''
      this.showNewPackageIdDialog = false
    },
    clearPackageId() {
      this.$emit('updatePackageId', this.newPackageId)
    },
    updatePatientDevice(prop, event) {
      this.$emit(`update:${prop}`, event)
    },
  },
}
